import React from 'react';
import {
  DialogTitle,
  DialogActions,
  DialogContent,
  Typography,
} from '@mui/material';
import infoIcon from '@src/assets/icons/info.png';
import warningIcon from '@src/assets/icons/waning-red.svg';

import { StyledDialog } from './index.style';

const NotificationDialogMobile = ({
  name,
  title,
  description,
  subDescription,
  variant = 'info', // info | warning
  open,
  width,
  //   contentComponent,
  actionComponent,
  onClose,
}) => {
  const renderIcon = () => {
    switch (variant) {
      case 'info':
        return infoIcon;
      case 'warning':
        return warningIcon;
      default:
        return null;
    }
  };

  const handleClose = () => onClose(name);

  return (
    <StyledDialog key={name} open={open} width={width} onClose={handleClose}>
      <div className="dialog-wrapper">
        <div className="content-wrapper">
          <DialogTitle className="title" classes={{ root: 'dialog-title' }}>
            <div className="header">
              <img src={renderIcon()} alt="icon" className="icon" />
              <Typography className="title-text">{title}</Typography>
            </div>
          </DialogTitle>
          <DialogContent classes={{ root: 'dialog-content' }}>
            <div
              className="description"
              // TODO: fix dangerouslySetInnerHTML
              // eslint-disable-next-line react/no-danger
              dangerouslySetInnerHTML={{ __html: description }}
            />
            {subDescription && (
              <Typography variant="body2" className="sub-description">
                - {subDescription}
              </Typography>
            )}
          </DialogContent>
          {actionComponent && (
            <DialogActions classes={{ root: 'dialog-action' }}>
              {actionComponent}
            </DialogActions>
          )}
        </div>
      </div>
    </StyledDialog>
  );
};

export default NotificationDialogMobile;
